import { useMemo } from 'react';
import { renderMarkdown } from '../lib/markdown';

/** Markdown from a meta repo file, sanitised (lib/markdown.ts) before it reaches the DOM. */
export function Markdown({ source }: { source: string }) {
  const html = useMemo(() => renderMarkdown(source), [source]);
  return <div className="prose" dangerouslySetInnerHTML={{ __html: html }} />;
}
